<template>
  <div class="company-complete">
    <img src="../../assets/success-application.png" alt="提交成功">
    <p class="company-complete-text">应用提交成功！我们将会在2～3个工作日内回复您</p>
    <p style="margin-top: 14px">
      <span class="company-complete-tip">如有任何疑问请联系</span>
      <span class="company-complete-email">openplatform-feedback@bilibili.com</span>
    </p>
    <div class="company-complete-bottom">
      <router-link :to="{name: 'companyCore'}">
        <bcc-button @click="$LogReport.sendCustomEvent('openplat_appsubmit_appmanage_click')" size="max-large">返回应用列表</bcc-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "addComplete",
}
</script>

<style scoped lang="scss">
.company-complete {
  max-width: 1168px;
  min-width: 960px;
  margin: 0 auto;
  text-align: center;

  img {
    margin-top: 134px;
    height: 205px;
    width: auto;
  }

  .company-complete-text {
    font-size: 16px;
    line-height: 20px;
    color: #212121;
    margin-top: 24px;
  }

  .company-complete-tip {
    font-size: 16px;
    line-height: 20px;
    color: #999999;
  }

  .company-complete-email {
    font-size: 16px;
    line-height: 20px;
    color: #23ADE5;
    margin-left: 4px;
  }

  .company-complete-bottom {
    margin: 28px 0;
  }
}
</style>
